
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 12a1 1 0 00-1 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h6a1 1 0 100-2H5a3 3 0 00-3 3v14a3 3 0 003 3h14a3 3 0 003-3v-6a1 1 0 00-1-1zm-15 .76V17a1 1 0 001 1h4.24a.998.998 0 00.71-.29l6.92-6.93L21.71 8a1.001 1.001 0 000-1.42l-4.24-4.29a1 1 0 00-1.42 0l-2.82 2.83-6.94 6.93a1.001 1.001 0 00-.29.71zm10.76-8.35l2.83 2.83-1.42 1.42-2.83-2.83 1.42-1.42zM8 13.17l5.93-5.93 2.83 2.83L10.83 16H8v-2.83z","fill":"url(#paint0_linearEditGradient)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linearEditGradient","x1":"3.209","y1":"20.948","x2":"21.314","y2":"3.58","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#9C27B0"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#9733EE"}})])])])
          )
        }
      }
    